export class TitleWithCountHelper {

    public static getTitle(title: string, count: number) {
        return title + " (" + count + ")";
    }
}